import { useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { track } from "./lib/api";
import { AuthProvider } from "./context/AuthContext";
import { CartProvider } from "./context/CartContext";
import { Navbar } from "./components/Navbar";
import { Footer } from "./components/Footer";
import { GearAdvisor } from "./components/GearAdvisor";
import { EmailCapturePopup } from "./components/EmailCapturePopup";
import Home from "./pages/Home";
import Shop from "./pages/Shop";
import ProductDetail from "./pages/ProductDetail";
import CartPage from "./pages/CartPage";
import Checkout from "./pages/Checkout";
import OrderConfirmation from "./pages/OrderConfirmation";
import ShowLanding from "./pages/ShowLanding";
import Events from "./pages/Events";
import Kits from "./pages/Kits";
import KitDetail from "./pages/KitDetail";
import Account from "./pages/Account";
import Admin from "./pages/Admin";
import { FieldGuide, Article } from "./pages/FieldGuidePages";
import Club from "./pages/Club";
import TrackOrder from "./pages/TrackOrder";
import { AuthPage, AuthCallback } from "./pages/AuthPages";
import { Contact, About } from "./pages/StaticPages";

function AppRouter() {
  const location = useLocation(); // read hash from here, not window.location.hash (not reactive)
  const [advisorOpen, setAdvisorOpen] = useState(false);
  const [advisorPrompt, setAdvisorPrompt] = useState(null);

  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  if (location.hash?.includes("session_id=")) return <AuthCallback />;

  const isShow = location.pathname === "/show";
  const openAdvisor = (prompt) => {
    const p = typeof prompt === "string" ? prompt : null;
    setAdvisorPrompt(p);
    setAdvisorOpen(true);
    track("advisor_open", location.pathname, p ? { prompt: p } : undefined);
  };

  return (
    <div className="min-h-screen flex flex-col bg-white text-[#0A0A0A]">
      {!isShow && <Navbar onOpenAdvisor={openAdvisor} />}
      <main className="flex-1">
        <Routes>
          <Route path="/" element={<Home onOpenAdvisor={openAdvisor} />} />
          <Route path="/shop" element={<Shop />} />
          <Route path="/product/:slug" element={<ProductDetail />} />
          <Route path="/kits" element={<Kits />} />
          <Route path="/kit/:slug" element={<KitDetail />} />
          <Route path="/cart" element={<CartPage />} />
          <Route path="/checkout" element={<Checkout />} />
          <Route path="/order/:orderId" element={<OrderConfirmation />} />
          <Route path="/show" element={<ShowLanding />} />
          <Route path="/events" element={<Events />} />
          <Route path="/field-guide" element={<FieldGuide />} />
          <Route path="/field-guide/:slug" element={<Article />} />
          <Route path="/club" element={<Club />} />
          <Route path="/track" element={<TrackOrder />} />
          <Route path="/login" element={<AuthPage mode="login" />} />
          <Route path="/register" element={<AuthPage mode="register" />} />
          <Route path="/account" element={<Account />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/about" element={<About />} />
        </Routes>
      </main>
      {!isShow && <Footer />}
      {!isShow && location.pathname !== "/checkout" && !location.pathname.startsWith("/order/") && !location.pathname.startsWith("/admin") && !advisorOpen && <EmailCapturePopup />}
      <GearAdvisor open={advisorOpen} initialPrompt={advisorPrompt} onClose={() => { setAdvisorOpen(false); setAdvisorPrompt(null); }} />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <CartProvider>
          <AppRouter />
          <Toaster position="bottom-right" richColors />
        </CartProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
